import React from "react";
import { QRCodeCanvas } from "qrcode.react";

// Renders an otpauth:// URI (not an image data-URI — B-19) as a QR code.
export default function ShowQRCode({ otpauthURL }) {
  if (!otpauthURL) return null;
  return (
    <QRCodeCanvas
      value={otpauthURL}
      size={200}
      includeMargin={true}
      level="M"
      role="img"
      aria-label="QR code to add Zun Drivers to your authenticator app"
    />
  );
}
